
interface PageInsetProps {
  children: React.ReactNode;
}

const PageContent = ({children}: PageInsetProps) => {

  return (
    <div className={"p-4"}>
      {children}
    </div>
  )

}

export default PageContent;